import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Container, Section, PageHero, CtaBanner, Clock, ArrowRight } from "../components/common";
import { useBlog } from "../lib/api";
import { useSeo, breadcrumbLd } from "../lib/seo";

export default function Blog() {
 const { data: posts = [] } = useBlog();
 useSeo({
 title: "Auto Repair Blog & Car Care Guides | RPM Auto Repair Riverside",
 description: "Expert, honest car-care advice from RPM Auto Repair's ASE Master Certified technicians. Maintenance guides, warning signs, money-saving tips & more.",
 path: "/blog",
 jsonLd: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }])],
 });
 const [feat, ...rest] = posts;
 return (
 <>
 <PageHero eyebrow="Expert Advice" title="The RPM Garage Blog"
 subtitle="Practical, jargon-free car-care guides written by the certified technicians who fix vehicles every day."
 image="https://images.unsplash.com/photo-1429772011165-0c2e054367b8?w=1400&q=80"
 crumbs={[{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }]} />
 <Section>
 <Container>
 {feat && (
 <Link to={`/blog/${feat.slug}`} className="group mb-12 grid overflow-hidden rounded-2xl border border-white/10 bg-steel lg:grid-cols-2">
 <div className="h-64 overflow-hidden lg:h-auto">
 <img src={feat.image} alt={feat.title} loading="lazy" className="h-full w-full object-cover opacity-80 transition-transform duration-500 group-hover:scale-105" />
 </div>
 <div className="flex flex-col justify-center p-8 lg:p-12">
 <span className="text-xs font-bold tracking-widest text-primary">Featured</span>
 <h2 className="mt-3 font-display text-2xl leading-tight text-white group-hover:text-primary lg:text-3xl">{feat.title}</h2>
 <p className="mt-3 text-muted-foreground leading-relaxed">{feat.excerpt}</p>
 <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary">Read Article <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" /></span>
 </div>
 </Link>
 )}
 <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
 {rest.map((p, i) => (
 <motion.article key={p.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
 transition={{ duration: 0.4, delay: (i % 3) * 0.07 }}
 className="group flex flex-col overflow-hidden rounded-xl border border-white/10 bg-steel">
 <Link to={`/blog/${p.slug}`} className="flex flex-1 flex-col" data-testid={`blog-${p.slug}`}>
 <div className="h-44 overflow-hidden">
 <img src={p.image} alt={p.title} loading="lazy" className="h-full w-full object-cover opacity-75 transition-transform duration-500 group-hover:scale-110" />
 </div>
 <div className="flex flex-1 flex-col p-6">
 <div className="flex items-center gap-2 text-xs tracking-wide text-muted-foreground"><Clock size={13} /> {p.readTime}</div>
 <h3 className="mt-3 font-display text-lg leading-snug text-white group-hover:text-primary">{p.title}</h3>
 <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground line-clamp-3">{p.excerpt}</p>
 </div>
 </Link>
 </motion.article>
 ))}
 </div>
 </Container>
 </Section>
 <CtaBanner />
 </>
 );
}
